import React, { useState } from 'react';

// Asume que tienes estilos para .confirmation-modal-overlay, etc.
// Usa los mismos estilos que tus otros modales.

const ChangePasswordModal = ({ onClose, onSave }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  // --- Estados de error y carga locales para el modal ---
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (newPassword !== confirmPassword) {
      setError("Las nuevas contraseñas no coinciden.");
      return;
    }

    if (newPassword.length < 6) {
      setError("La nueva contraseña debe tener al menos 6 caracteres.");
      return;
    }

    setLoading(true);
    try {
      // onSave es la función 'handleChangePassword' que pasamos desde ProfileView
      await onSave(currentPassword, newPassword);
      // Si tiene éxito, onSave (desde ProfileView) cerrará el modal
    } catch (err) {
      // Si onSave (reauthenticate) falla, captura el error y muéstralo aquí
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="confirmation-modal-overlay" onClick={onClose}>
      <div className="confirmation-modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '450px' }}>
        <form onSubmit={handleSubmit}>
          <h3>Cambiar Contraseña</h3>
          <p>Ingresa tu contraseña actual y una nueva contraseña.</p>

          <div className="input-group" style={{ marginBottom: '1rem' }}>
            <label style={{ marginBottom: '5px', display: 'block' }}>Contraseña Actual</label>
            <input
              id="change-pwd-current"
              name="current-password"
              type="password"
              placeholder="••••••••"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>

          <div className="input-group" style={{ marginBottom: '1rem' }}>
            <label style={{ marginBottom: '5px', display: 'block' }}>Nueva Contraseña</label>
            <input
              id="change-pwd-new"
              name="new-password"
              type="password"
              placeholder="Nueva (mín. 6 caracteres)"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="new-password"
              required
            />
          </div>

          <div className="input-group" style={{ marginBottom: '1rem' }}>
            <label style={{ marginBottom: '5px', display: 'block' }}>Confirmar Nueva Contraseña</label>
            <input
              id="change-pwd-confirm"
              name="confirm-password"
              type="password"
              placeholder="Confirmar nueva contraseña"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              autoComplete="new-password"
              required
            />
          </div>

          {/* --- Error local del modal --- */}
          {error && <div className="alert alert-danger" style={{ padding: '10px', margin: '10px 0', backgroundColor: '#f8d7da', color: '#721c24' }}>{error}</div>}

          <div className="confirmation-modal-actions" style={{ marginTop: '1.5rem' }}>
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? "Guardando..." : "Guardar Contraseña"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;